import { useQuery } from '@tanstack/react-query';
import { getDashboard } from '../services/api';

export const useDashboard = () => {
  return useQuery({
    queryKey: ['dashboard'],
    queryFn: getDashboard,
    refetchInterval: 60000,
  });
};
